import { colors } from '../../tokens/colors';
import { borderWidths } from './borderWidths';

const createBorder = (
  color: string,
  borderWidth: keyof typeof borderWidths = 's',
) => `${borderWidths[borderWidth]}px solid ${color}`;

export const borders = {
  active: createBorder(colors['status.active']),
  'active.light': createBorder(colors['border.status.active.light']),
  avatar: createBorder(colors.background, 'm'),
  border: createBorder(colors.border),
  'border.divider': createBorder(colors['border.divider']),
  'inverse.border.divider': createBorder(colors['inverse.border.divider'], 'm'),
  quote: createBorder(colors.border, 'l'),
};
